import { Injectable } from "@angular/core";
import { EstatusJSON } from "../../models/EstatusJSON";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { LocationRelatedDTO } from "src/app/features/map-features/sections/locations-section/models/LocationRelatedDTO";

@Injectable({
  providedIn: "root",
})
export class LocationRelatedAPIService implements IApiBase{
  configUrl: string;

  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }


  // ------------------ api  --------------
  GetAllByIdentifier (identifier: string, includeGeoJson: boolean) {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/LocationRelated/GetRelatedByIdentifier?identifier="+ identifier + "&includeGeoJson=" + includeGeoJson,
      {}
    );
  }

  GetRelatedFilteredByIdentifier (parentIdentifier: string, identifier: string, includeGeoJson: boolean) {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/LocationRelated/GetRelatedFilteredByIdentifier?parentIdentifier="+ parentIdentifier + "&identifier="+ identifier +  "&includeGeoJson=" + includeGeoJson,
      {}
    );
  }

  UpdateLocationRelatedOrder(locationRelatedList : LocationRelatedDTO[], identifier : string) {
    if(!environment.production) console.log("UpdateLocationRelatedOrder", locationRelatedList, identifier);
    
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/LocationRelated/UpdateLocationRelatedOrder?identifier=" + identifier, locationRelatedList, {}
    );
  }
}
